import { render, staticRenderFns } from "./ScopeTree.vue?vue&type=template&id=5e6616c4"
import script from "./ScopeTree.vue?vue&type=script&lang=js"
export * from "./ScopeTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports